import { IUserHttpParams } from '@core/interfaces/api.interface';
import {
	IRouteBaseDefinition,
	RouteBasePathEnum
}                          from '@core/interfaces/route.interface';


export enum UserRoutesEnum {
	ListPage = '',
	DetailPage = ':userId',
	FormPageCreate = 'create',
	FormPageUpdate = ':userId/update',
	FormPageChangePassword = ':userId/change-password',
}

export interface UserListPageRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.Users;

	path: UserRoutesEnum.ListPage;

	queryParams?: IUserHttpParams;
}

export interface UserDetailPageRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.Users;

	path: UserRoutesEnum.DetailPage;

	params: { userId: string };
}

export interface UserFormPageCreateRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.Users;

	path: UserRoutesEnum.FormPageCreate;
}

export interface UserFormPageUpdateRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.Users;

	path: UserRoutesEnum.FormPageUpdate;

	params: { userId: string };
}

export interface UserFormPageChangePasswordRoute extends IRouteBaseDefinition {
	basePath: RouteBasePathEnum.Users;

	path: UserRoutesEnum.FormPageChangePassword;

	params: { userId: string };
}
